import { actionTypes } from "./actions";

const initialState = {
  data: [],
  comboEdit: {
    ComboSK: "",
    ComboCode: "",
    ComboDescription: "",
    ComboActiveFrom: "",
    ComboActiveTo: "",
    ComboProduct_ProductSK: [],
    EZDExclusion_EZDSK: [],
    ComboProductQuantityOfPacks: "",
    totalQuantityOfPacks: "",
  },
  comboProducts: [],
  comboEzds: [],
  comboProductsDelete: [],
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.SET_COMBOS:
      return {
        ...state,
        data: payload,
      };

    case actionTypes.SET_COMBO_FILTERED_RESULTS:
      return {
        ...state,
        data: payload,
      };

    case actionTypes.SET_DELETE_COMBO_PRODUCT:
      return {
        ...state,
        comboProductsDelete: payload,
      };

    case actionTypes.SET_COMBOS_BY_ID:
      return {
        ...state,
        comboEdit: payload,
      };

    case actionTypes.SET_COMBO_PRODUCTS:
      return {
        ...state,
        comboProducts: payload,
      };

    case actionTypes.SET_COMBO_EZDS:
      return {
        ...state,
        comboEzds: payload,
      };

    case actionTypes.EDIT_COMBO_FORM_CHANGE:
      return {
        ...state,

        comboEdit: {
          ...state.comboEdit,
          [payload.name]: payload.value,
        },
      };

    case actionTypes.SET_UPDATED_COMBO:
      return {
        ...state,
        comboEdit: payload,
      };

    default:
      return {
        ...state,
      };
  }
};
